import React from "react";
import styles from "./NextButton.scss";
import { Button } from "../../../../components/Button/Button";

export interface INextButtonProps {
  onClick: any;
  isEnable: boolean;
  isLoading: boolean;
  disabled?: boolean;
}

const NextButton = (props: INextButtonProps): JSX.Element => {
  const { onClick, isEnable, isLoading, disabled } = props;
  return (
    <Button
      type="primary"
      className={!isEnable ? styles.disabledButton : styles.button}
      onClick={onClick}
      //disabled={!isEnable}
      disabled={disabled}
      loading={isLoading}
    >
      <span className={styles.text}>{"Nastavi"}</span>
    </Button>
  );
};

export default NextButton;



// WEBPACK FOOTER //
// ./src/containers/SelectModulePage/TitleWithModule/NextButton/index.tsx